"use strict";

module.exports = function ($stateProvider) {
    $stateProvider.state("dashboard.validations", {
        url: "/validations",
        templateUrl: "dashboard-validations/dashboard-validations.html",
        controller: "dashboardValidationsCtrl as ctrl",
        data: {
            authorizedRoles: ["admin", "owner", "supervisor"],
        },
    });
};
